import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const overrides = {
	'.comparisonCardBlock__section': {
		...theme.mixins.layout_styles,
		'.comparisonCardBlock__slider_navigation': {
			top: remCalc('85px'),
			zIndex: 2,
			position:'relative',
			display: 'flex',
			alignItems: 'center',
			gap: remCalc(20),
            justifyContent: 'flex-end',
            [theme.breakpoints.down('sm')]: {
                justifyContent: 'center',
            },
            [theme.breakpoints.up('md')]: {
            	top: remCalc('50px'),
            },
			button: {
				display: 'inline-flex',
				alignItems: 'center',
                border: 'none',
				justifyContent: 'center',
                background: 'transparent',
				backgroundColor: 'transparent',
				color: getColor('ivory', 600),
				transition: 'all .2s',

				svg: {
					width: remCalc(59),
					height: remCalc(38),
					path: {
						fill: getColor('ivory', 600),
					},
					transition: 'all var(--transition-duration) ease-in-out',
					'*': {
						transition: 'all var(--transition-duration) ease-in-out',
					}
				},

				'&:hover': {
					'svg > path': {
						fill: getColor('ivory', 700),
					}
				},

				'&:focus-visible': {
					outline: `${remCalc(2)} solid ${getColor('blue', 400)}`,
					outlineOffset: remCalc(2),
				},

				'@media (hover: hover) and (pointer: fine)': {
					'&:hover': {
						cursor: 'pointer',
						color: getColor('ivory', 700),
						// background: getColor('ivory', 400),
					},
				},
			},
		},
		'.comparisonCardBlock__title_wrapper': {
			position:'relative',
			'.comparisonCardBlock__title': {
				textTransform: 'uppercase',
				textAlign: 'center',
				marginBottom: remCalc('-75px'),
				[theme.breakpoints.up('md')]: {
					textAlign: 'left',
					marginBottom: remCalc('32px'),
				},
			},
		},
		'.comparisonCardBlock__primary_card': {
			position: 'relative',
			'.comparisonCardBlock__primary_card_image': {
				aspectRatio: '776/356',
				backgroundSize: 'cover',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center',
				backgroundColor: getColor('ivory',700),
				display: 'block',
			},
			'.comparisonCardBlock__primary_card_title': {
				textTransform: 'uppercase',
				textAlign: 'center',
				marginBottom: remCalc('40px'),
				[theme.breakpoints.up('md')]: {
					textAlign: 'left',
				},
			}
		},
		'.comparisonCardBlock__secondary_cards_row': {
			marginTop: remCalc('32px'),
			'.comparisonCardBlock__secondary_cards_row_title': {
				textAlign: 'center',
				textTransform: 'uppercase',
				marginBottom: remCalc('24'),
				[theme.breakpoints.up('md')]: {
					marginBottom: remCalc('64'),
				},
			},
			'.comparisonCardBlock__secondary_card': {
				position: 'relative',
				'.comparisonCardBlock__secondary_card_image': {
					aspectRatio: '40/71',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					backgroundPosition: 'center',
					backgroundColor: getColor('ivory',700),
					display: 'block',
					[theme.breakpoints.up('md')]: {
						aspectRatio: '314/169',
					},
				},
				'.comparisonCardBlock__secondary_card_title': {
					textAlign: 'center',
					fontWeight: 400,
					textTransform: 'uppercase',
					marginTop: remCalc('32px'),
				}
			}
		}
	}
}

const styles = {};

export default styles;